import { ENV } from '@/common/app/env';
import {
  type LotteryTicketType,
  type TicketRewardType,
} from '@/common/types/lottery';

import diamondBgPng from '/img/lottery/diamond-bg.png';
import diamondBgWebp from '/img/lottery/diamond-bg.webp';
import goldBgPng from '/img/lottery/gold-bg.png';
import goldBgWebp from '/img/lottery/gold-bg.webp';
import silverBgPng from '/img/lottery/silver-bg.png';
import silverBgWebp from '/img/lottery/silver-bg.webp';

const lotteryBackgrouds: Record<
  LotteryTicketType,
  { png: string; webp: string }
> = {
  Silver: {
    png: silverBgPng,
    webp: silverBgWebp,
  },
  Gold: {
    png: goldBgPng,
    webp: goldBgWebp,
  },
  Diamond: {
    png: diamondBgPng,
    webp: diamondBgWebp,
  },
};

const lotteryBackgroundList: {
  name: LotteryTicketType;
  png: string;
  webp: string;
}[] = Object.entries(lotteryBackgrouds).map(([name, { png, webp }]) => ({
  name: name as LotteryTicketType,
  png,
  webp,
}));

const ticketRewardToTier: Record<TicketRewardType, LotteryTicketType> = {
  silverTicket: 'Silver',
  goldTicket: 'Gold',
  diamondTicket: 'Diamond',
};

// in seconds
const animateDuration = isNaN(Number(ENV.LOTTERY_ANIMATE_DURATION))
  ? 8
  : Number(ENV.LOTTERY_ANIMATE_DURATION);

export {
  animateDuration,
  lotteryBackgrouds,
  lotteryBackgroundList,
  ticketRewardToTier,
};
